export default () => ({
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitButtonContainer: {
        marginTop: '2.5rem',
        marginBottom: '2rem'
    },
    submitError: { alignSelf: 'center' },
    ssoUserIdInfo: {
        position: 'relative' as 'relative',
        top: '-15px'
    },
    infoText: {
        lineHeight: '32px',
        paddingLeft: '15px',
        fontSize: '13px'
    },
    infoIcon: {
        width: '30px',
        height: '30px'
    }
});